import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ValidationService } from './validation.service';

@Component({
  selector: 'control-messages',
  template: `
    <div *ngIf="errorMessage">
      <small class="form-text text-danger">
        {{ errorMessage }}
      </small>
    </div>
  `
})
export class ControlMessagesComponent {

  @Input() control: FormControl;

  get errorMessage(): string | null {

    if (!this.control) {
      return null;
    }

    if (!this.control.errors || !this.control.touched) {
      return null;
    }

    for (const propertyName in this.control.errors) {
      if (this.control.errors.hasOwnProperty(propertyName)) {
        return ValidationService.getValidatorErrorMessage(
          propertyName,
          this.control.errors[propertyName]
        );
      }
    }

    return null;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/control-messages/control-messages.component.ts